import { Globe } from "lucide-react";

export default function LanguageSwitcher() {
  return (
    <button
      type="button"
      disabled
      className="flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-300"
      title="Français"
      aria-label="Langue française"
    >
      <Globe size={16} />
      <span>FR</span>
    </button>
  );
}
